import ServiceResponseTime from "../enums/ServiceResponseTime";

const ResponseMessageHandler=(responseTime:string,traceNumber:string)=>{

    return `متقاضی/مشترک محترم درخواست شما با کد رهگیری ${traceNumber} در سامانه شرکت آب و فاضلاب ثبت گردید. درصورت دارا بودن شرایط و تکمیل مدارک این درخواست در${responseTime} روز کاری به اتمام می رسد.`
}
export default ResponseMessageHandler;